import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Spinner } from './ui';

interface UnAuthRouteProps {
  children: React.ReactNode;
}

export default function UnAuthRoute({ children }: UnAuthRouteProps) {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center gh-surface">
        <Spinner size="lg" />
      </div>
    );
  }

  return currentUser ? <Navigate to="/dashboard" /> : <>{children}</>;
} 